import React, { FC } from 'react';
import { EMAIL, EMAIL_TYPE, FIRST_NAME, SCHEDULED_AT, SCHEDULED_EMAILS } from '../../utils/constants/labels';
import { Tag } from 'antd';
import { DatePreview, emailTypeColors } from '../../utils/helpers';
import { DATE_FORMAT, formatDate } from '../../utils/timeUtils';
import { api } from '../../api/api';
import PageHeader from '../common/layout/PageHeader';
import Table from '../common/table/Table';
import styled from 'styled-components';
import colors from '../../utils/colors';

type Props = {};

const emailTypeLabels = {
  RESET_TRIAL: 'Reset trial',
  RESET_TRIAL_REMINDER: 'Reset trial reminder',
  TRIAL_EXPIRATION: 'Trial expiration',
  GIFT_MEMBERSHIP_REMINDER: 'Gift membership reminder',
  MOBILE_SIGNUP_REMINDER_1: 'Signup reminder 1',
  MOBILE_SIGNUP_REMINDER_2: 'Signup reminder 2',
  MOBILE_SIGNUP_REMINDER_3: 'Signup reminder 3',
  MOBILE_SIGNUP_REMINDER_4: 'Signup reminder 4'
};

const columns = [
  {
    title: FIRST_NAME,
    dataIndex: 'firstName',
    width: '20%'
  },
  {
    title: EMAIL,
    dataIndex: 'email',
    width: '50%'
  },
  {
    title: EMAIL_TYPE,
    dataIndex: 'type',
    width: '15%',
    render: value => <Tag color={emailTypeColors[value]}>{emailTypeLabels[value]}</Tag>
  },
  {
    title: SCHEDULED_AT,
    dataIndex: 'scheduledAt',
    width: '15%',
    render: value => (value ? <DatePreview>{formatDate(value, DATE_FORMAT)}</DatePreview> : null)
  }
];

const ScheduledEmails: FC<Props> = () => {
  return (
    <Container>
      <PageHeader title={SCHEDULED_EMAILS} />
      <Table columns={columns} getData={api.getScheduledEmails} idPropName={'id'} />
    </Container>
  );
};

export default ScheduledEmails;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1;
  background-color: ${colors.white};
  position: relative;
`;
